import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { canAccess } from '../lib/roles';

/**
 * Renders children only if the current user's role can access the current path.
 * Otherwise redirects to dashboard.
 */
export default function ProtectedRoute({ children }) {
  const { role, profile } = useAuth();
  const { pathname } = useLocation();

  if (!canAccess(role, pathname, profile?.allowed_tab_paths)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
